import { Container} from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <Container>
            <p className="custom-font" style={{textAlign:"center",fontWeight:"bold"}} >Payment System Comming Soon!</p>
        </Container>
    );
};

export default Payment;